import Price from '~/utils/Price';
import { CroatiaMaxPriceThirdPriceDeviationResponse } from 'com.cogvio.pricemonitor.api';

import { ThirdPriceDeviation } from './ThirdPriceDeviation';

export const mapThirdPriceDeviation = (thirdPriceDeviation: CroatiaMaxPriceThirdPriceDeviationResponse) =>
	new ThirdPriceDeviation(
		new Price(thirdPriceDeviation.firstCountryPriceValue.toString(), thirdPriceDeviation.firstCountryPriceCurrency),
		new Price(
			thirdPriceDeviation.comparativePriceInFirstTwoCountriesValue.toString(),
			thirdPriceDeviation.comparativePriceInFirstTwoCountriesCurrency
		),
		thirdPriceDeviation.thirdCountryAlpha2,
		new Price(thirdPriceDeviation.thirdCountryPriceValue.toString(), thirdPriceDeviation.thirdCountryPriceCurrency),
		thirdPriceDeviation.deviationPercents,
		thirdPriceDeviation.aboveThreshold
	);
